<div class="page">
  <mat-tab-group disableRipple class="dialog-table" mat-stretch-tabs="false">
    <mat-tab label="Table" [hidden]="!hot || !hot.ready">
      @if (hot && hot.ready && hot.instance) {
        <div class="row utils-bar justify-start hot-utils">
          <div class="row table-filter space-between">
            <div class="row center min-height">
              <utils-bar #utils_bar
                         [search]="true"
                         (searchValueSubmitted)="search=$event;hot.filter(search)"
                         (searchCleared)="hot.clear();search=''">
              </utils-bar>
              <account-filter (accountFilterEmitter)="hot.filter_account($event)" [allow_blank]="true"></account-filter>
              @if (manualInsert) {
                <button mat-stroked-button class="hot-insert-button" matTooltip="Insert new row"
                        (click)="addSpareRow()">
                  <i class="fa fa-plus"></i>&nbsp;Add row
                </button>
              }
            </div>
          </div>
        </div>
      }
      <div class="md-padding" style="position:relative;">
        <div (window:resize)="hot.onResize($event)" [style.height.px]="hot.window_height">
          <div #hot_anchor [id]="hot.handson_id" class="hot-template-anchor">
          </div>
        </div>
      </div>
    <!--</ng-template>-->
  </mat-tab>

  @if (hot && hot.ready && hot.instance) {
    <mat-tab label="Pivot">
      <ng-template matTabContent>
        <!--TODO make height dynamic?-->
        <pivot-view [hot]="hot"></pivot-view>
      </ng-template>
    </mat-tab>
  }
  @if (hot && hot.ready && hot.instance) {
    <mat-tab
      label="History">
      <ng-template matTabContent>
        <div style="width: 100%; overflow:auto;">
          <!--TODO make height dynamic?-->
          <history-table [hot]="hot"></history-table>
        </div>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
</div>
